import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";
import { faGithub } from "@fortawesome/free-brands-svg-icons/faGithub";
import { faGlobe } from "@fortawesome/free-solid-svg-icons/faGlobe";

const Project = (props) => {
	const { logo, title, description, githubLink, liveLink, technologies } =
		props;

	return (
		<React.Fragment>
			<div className="project">
				<div className="project-container">
					<div className="project-logo">
						<img src={logo} alt="logo" />
					</div>
					<div className="project-title">{title}</div>
					<div className="project-description">{description}</div>

					{technologies && technologies.length > 0 && (
						<div className="project-tech-stack">
							{technologies.map((tech, index) => (
								<span key={index} className="tech-item">
									{tech}
									{index !== technologies.length - 1 && (
										<span className="tech-divider">
											{" "}
											•{" "}
										</span>
									)}
								</span>
							))}
						</div>
					)}

					<div className="project-links">
						{githubLink ? (
							<a
								href={githubLink}
								className="project-link-icon"
								target="_blank"
								rel="noreferrer"
								aria-label={`${title} GitHub link`}
							>
								<FontAwesomeIcon icon={faGithub} />
							</a>
						) : (
							<span className="project-link-icon disabled">
								<FontAwesomeIcon icon={faGithub} />
							</span>
						)}

						{liveLink ? (
							<a
								href={liveLink}
								className="project-link-icon"
								target="_blank"
								rel="noreferrer"
								aria-label={`${title} Live link`}
							>
								<FontAwesomeIcon icon={faGlobe} />
							</a>
						) : (
							<span className="project-link-icon disabled">
								<FontAwesomeIcon icon={faGlobe} />
							</span>
						)}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Project;
